import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "libraries"
    }}>{`Libraries`}</h1>
    <p>{`To make integrating with the Import API as easy as possible, we've created some client libraries for you to use. Have your own library? Want to contribute to ours? `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/commerce-knowledge-base/kb/help-center-guide/magento-help-center-user-guide.html"
      }}>{`Reach out to us!`}</a></p>
    <h2 {...{
      "id": "clojure"
    }}>{`Clojure`}</h2>
    <p>{`You can install the RJMetrics Clojure client library by adding the following dependency to your `}<inlineCode parentName="p">{`project.clj`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-clojure"
      }}>{`[rjmetrics "0.2.0"]
`}</code></pre>
    <p>{`Now, you can use the library like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-clojure"
      }}>{`(ns example
    (:require [rjmetrics.core :as rjmetrics]))

(def config-map {:client-id 1
                  :api-key "your-api-key"})

(when (rjmetrics/authenticated? config-map)
  ;; do stuff with client
  )
`}</code></pre>
    <p>{`For more information, check out the `}<a parentName="p" {...{
        "href": "https://github.com/RJMetrics/RJMetrics-clj"
      }}>{`source code on Github`}</a>{`.`}</p>
    <h2 {...{
      "id": "javascript"
    }}>{`Javascript`}</h2>
    <p>{`The RJMetrics Javascript client library is available via npm:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install rjmetrics
`}</code></pre>
    <p>{`You can also install it via npm by adding the following line to the dependencies field in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`"rjmetrics": "0.2.0"
`}</code></pre>
    <p>{`Now, you can use the library like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var rjmetrics = require("rjmetrics");
client = rjmetrics.Client(client_id, api_key);

# do stuff with client
`}</code></pre>
    <p>{`For more information, check out the `}<a parentName="p" {...{
        "href": "https://github.com/RJMetrics/RJMetrics-js"
      }}>{`source code on Github`}</a>{`.`}</p>
    <h2 {...{
      "id": "php"
    }}>{`PHP`}</h2>
    <p>{`The RJMetrics PHP client library can be installed using `}<a parentName="p" {...{
        "href": "https://getcomposer.org"
      }}>{`Composer`}</a>{`.`}</p>
    <p>{`Add the following to your project's `}<inlineCode parentName="p">{`composer.json`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`  {
    "require": {
    ...
    "rjmetrics/rjmetrics-client": "0.2.0"
  }
}
`}</code></pre>
    <p>{`Now, you can use the library in your script, like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`<?php

require 'vendor/autoload.php';
$client = new RJMetrics\\Client($myClientId, $myApiKey);

/* do stuff with $client */

?>
`}</code></pre>
    <p>{`For more information, you can `}<a parentName="p" {...{
        "href": "https://github.com/RJMetrics/RJMetrics-php"
      }}>{`view the source on Github`}</a>{`.`}</p>
    <h2 {...{
      "id": "python"
    }}>{`Python`}</h2>
    <p>{`You can install the RJMetrics Python client library with `}<inlineCode parentName="p">{`pip`}</inlineCode>{` or `}<inlineCode parentName="p">{`easy_install`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`pip install rjmetrics
`}</code></pre>
    <p>{`You can also install it by adding the following line to a pip requirements file:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`rjmetrics
`}</code></pre>
    <p>{`Now, you can use the library like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`from rjmetrics.client import Client
client = Client(client_id, api_key)

# do stuff with client
`}</code></pre>
    <p>{`For more information, check out the `}<a parentName="p" {...{
        "href": "https://github.com/RJMetrics/RJMetrics-py"
      }}>{`source code on Github`}</a>{`.`}</p>
    <h2 {...{
      "id": "ruby"
    }}>{`Ruby`}</h2>
    <p>{`The RJMetrics Ruby client library is available as a gem:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`gem install rjmetrics-client
`}</code></pre>
    <p>{`You can also install it via bundler by adding the following line in your `}<inlineCode parentName="p">{`Gemfile`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`gem 'rjmetrics-client'
`}</code></pre>
    <p>{`Now, you can use the library like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ruby"
      }}>{`require "rjmetrics_client"
client = RJMetricsClient.new(client_id, api_key)

# do stuff with client
`}</code></pre>
    <p>{`For more information, check out the `}<a parentName="p" {...{
        "href": "https://github.com/RJMetrics/RJMetrics-ruby"
      }}>{`source code on Github`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      